import API from './API';

export default class Auth extends API {

  static refresh(dados) {
    return super.post(`/auth/refresh-token`,dados);
  }

  static entrar(dados){
    return super.post(`/auth`, dados);
  }

  static cadastro(dados){
    return super.post(`/auth/cadastro`, dados);
  }

  static sair(dados){
    return super.post(`/auth/sair`, dados);
  }

  static status(dados){
	return super.post(`/auth/status`, dados);
  }

}



// WEBPACK FOOTER //
// ./src/services/api/Auth.js